module.exports = __webpack_public_path__ + "static/media/class-5.2.6acb40c7.PNG";